export default "__VITE_ASSET__B6UOf$OQ__"